import config from 'config';
import { hideIntercomMessenger } from '../intercom/intercom';

export class filePickerHelper {

    static initialize() {
        if (window.filepicker) {
            window.filepicker.setKey(config.filepicker.key);
        }
    }

    static pickAndStore(customOptions, callbackFunc) {
        hideIntercomMessenger();
        // These are options that are shared among all the file picker components: logo, banner, thumbnail
        const sharedOptions = {
            conversions: ['crop', 'rotate', 'filter'],
            imageQuality: 90,
            multiple: false,
            cropForce: true
        };
        const pickerOptions = {
            ...sharedOptions,
            ...customOptions
        };
        const storeOptions = {
            location: 'S3',
            access: 'public',
            path: `${config.filepicker.storage.s3.path}/${customOptions.fileType}/`
        };
        // For more details see: https://www.filepicker.com/docs/file-ingestion/javascript-api/pick-and-store
        window.filepicker.pickAndStore(
            pickerOptions,
            storeOptions,
            function (Blobs) {
                // Encode the s3 file name
                const sliceIndex = Blobs[0].key.lastIndexOf('/');
                const s3subfolder = Blobs[0].key.slice(0, sliceIndex);
                const s3fileName = encodeURIComponent(Blobs[0].key.split('/').pop());
                const s3location = `${s3subfolder}/${s3fileName}`;
                callbackFunc(`${config.filepicker.storage.s3.baseUrl}/${Blobs[0].container}/${s3location}`, Blobs);
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app-lib/helpers/filepicker.js